// src/components/vendorChat/MessageItem.tsx
import { Flex } from '@chakra-ui/react';
import { ReactNode } from 'react';

interface Props {
  variant: 'vendor' | 'user';
  children: ReactNode;
}

const MessageItem = ({ variant, children }: Props) => (
  <Flex py={2} direction="column" align={variant === 'vendor' ? 'flex-end' : 'flex-start'} px={2}>
    {children}
  </Flex>
);

export default MessageItem;
